/* unplugin-vue-components disabled */import { render } from "./address_show.vue?vue&type=template&id=cc2e8c34"
import script from "./address_show.vue?vue&type=script&lang=js"
export * from "./address_show.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__